<template>
  <div class="project-management-permissions">
    <LeftRightBox :leftWidthDefault="600">
      <template slot="left">
        <SimpleTable
          ref="leftTable"
          table-code="projectManagementPermissionsLeft"
          :menus="['查询', '批量修改', '插入', '批量删除']"
          :columns="columns.left"
          :data="tableData.left"
          :loading="loading.left"
          @row-select="onRowSelectLeft"
          @modify-data-change="onModifyDataChangeLeft"
        />
      </template>
      <template slot="right">
        <div class="top">
          <SimpleTable
            class="topLeft"
            ref="topTable"
            table-code="projectManagementPermissionsTop"
            :menus="['查询', '批量修改', '插入', '批量删除']"
            :columns="columns.top"
            :data="tableData.top"
            :loading="loading.top"
            @row-select="onRowSelectTop"
            @modify-data-change="onModifyDataChangeTop"
          />
          <SimpleTable
            class="topRight"
            ref="topRightTable"
            table-code="projectManagementPermissionsTopRight"
            :menus="['查询', '批量修改', '插入', '批量删除']"
            :columns="columns.topRight"
            :data="tableData.topRight"
            :loading="loading.topRight"
            @row-select="onRowSelectTopRight"
            @modify-data-change="onModifyDataChangeTopRight"
          />
        </div>

        <SimpleTable
          class="bottom"
          ref="bottomTable"
          table-code="projectManagementPermissionsBottom"
          :menus="['查询', '批量修改', '插入', '批量删除']"
          :columns="columns.bottom"
          :data="tableData.bottom"
          :loading="loading.bottom"
          :menusMergeAfter="menusMergeAfterBottom"
          @modify-data-change="onModifyDataChangeBottom"
        />
      </template>
    </LeftRightBox>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import { sortRecords, addCbFn, getOptions, dfsFn } from '@/utils/index'

export default {
  name: 'ProjectManagementPermissions',
  components: {
    SimpleTable,
    LeftRightBox
  },
  data() {
    return {
      columns: {
        left: [
          {
            field: 'name',
            title: '项目名称',
            canEdit: true,
            canModify: true
          },
          {
            field: 'regionName',
            title: '所在地区',
            editModal: {
              columns: [{ field: 'name', title: '所在地区' }],
              options: async () => {
                const res = await this.$service.get('/region/list', {})
                return sortRecords(res?.data || [])
              },
              confirm: (selectedCellInfos, res) => {
                const row = res[0][0].originData
                selectedCellInfos.forEach(cells => {
                  const obj = cells[0].originData
                  this.$set(obj, 'regionName', row.name)
                  this.$set(obj, 'regionId', row.id)
                })
              }
            },
            canModify: true
          },
          {
            field: 'engineeringNature',
            title: '工程性质',
            ...getOptions({
              title: '工程性质',
              key: 'engineeringNature',
              options: [{ name: '新建' }, { name: '修缮' }]
            }),
            canModify: true,
            canEdit: true
          },
          {
            field: 'type',
            title: '项目类型',
            ...getOptions({
              title: '项目类型',
              key: 'type',
              options: [
                { name: '业主项目' },
                { name: 'BOT项目' },
                { name: 'BOO项目' },
                { name: 'EPCO项目' },
                { name: 'EPC项目' },
                { name: '施工总包项目' }
              ]
            }),
            canEdit: true,
            canModify: true
          },
          {
            field: 'address',
            title: '详细地址',
            canEdit: true,
            canModify: true
          }
        ],
        top: [
          {
            field: 'name',
            title: '单位名称',
            canModify: true,
            ...getOptions(
              {
                title: '单位名称',
                key: 'name',
                options: () => this.getUnitOptions(),
                confirm: (selectedCellInfos, res) => {
                  const row = res[0][0].originData
                  selectedCellInfos.forEach(cells => {
                    const obj = cells[0].originData
                    this.$set(obj, 'name', row.name)
                    this.$set(obj, 'toUnitId', row.id)
                  })
                }
              },
              false
            )
          },
          { field: 'type', title: '单位类型' },
          { field: 'contactorPhone', title: '联系电话' },
          { field: 'contactor', title: '联系人' },
          { field: 'regionName', title: '所在地区' }
        ],
        topRight: [
          {
            field: 'lockNumber',
            title: '加密锁号',
            canModify: true,
            ...getOptions(
              {
                title: '加密锁号',
                key: 'lockNumber',
                options: () => this.getLockOptions(),
                confirm: (selectedCellInfos, res) => {
                  const row = res[0][0].originData
                  selectedCellInfos.forEach(cells => {
                    const obj = cells[0].originData
                    this.$set(obj, 'lockNumber', row.name)
                    this.$set(obj, 'unitLockId', row.id)
                  })
                }
              },
              false
            )
          },
          { field: 'contactor', title: '联系人' },
          { field: 'contactorPhone', title: '联系电话' }
        ],
        bottom: [
          {
            field: 'menuName',
            title: '功能模块',
            // canModify: true,
            tree: true
            // ...getOptions(

            //   false
            // )
          },
          {
            field: 'writeFlag',
            title: '维护权限',
            cellType: 'checkbox',
            canEdit: true,
            canModify: true,
            multiple: true
          },
          {
            field: 'readFlag',
            title: '只读权限',
            cellType: 'checkbox',
            canEdit: true,
            canModify: true,
            multiple: true
          },
          {
            field: 'approvalFlag',
            title: '审核权限',
            cellType: 'checkbox',
            canEdit: true,
            canModify: true,
            multiple: true
          }
        ]
      },
      tableData: {
        left: [],
        top: [],
        topRight: [],
        bottom: []
      },
      loading: {
        left: false,
        top: false,
        topRight: false,
        bottom: false
      },
      curentSelect: {
        left: null,
        top: null,
        topRight: null,
        right: null
      },

      menuOptions: null
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.getTableLeft()
    },
    async getTableLeft() {
      this.tableData.left = []
      this.tableData.top = []
      this.tableData.topRight = []
      this.tableData.bottom = []
      this.loading.left = true
      const res = await this.$service.get('/project/list', {})
      this.loading.left = false
      this.tableData.left = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.leftTable?.initialized()
    },
    async getTableTop() {
      this.tableData.top = []
      this.tableData.topRight = []
      this.tableData.bottom = []
      if (!this.curentSelect.left?.id) return
      this.loading.top = true
      const res = await this.$service.get('/project-authorize/unit/list', {
        projectId: this.curentSelect.left.id
      })
      this.loading.top = false
      this.tableData.top = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.topTable?.initialized()
    },
    async getTableTopRight() {
      this.tableData.topRight = []
      if (!this.curentSelect.top?.id) return
      this.loading.topRight = true
      const res = await this.$service.get('/project-authorize/unit-lock/list', {
        projectId: this.curentSelect.left.id,
        projectAuthorizeUnitId: this.curentSelect.top.id
      })
      this.loading.topRight = false
      this.tableData.topRight = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.topRightTable?.initialized()
    },
    async getTableBottom() {
      this.tableData.bottom = []
      if (!this.curentSelect.top?.id) return
      this.loading.bottom = true
      const res = await this.$service.get('/project-authorize/unit-menu/list', {
        projectId: this.curentSelect.left.id,
        projectAuthorizeUnitId: this.curentSelect.top.id
      })

      this.loading.bottom = false
      this.tableData.bottom = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.bottomTable?.initialized()
    },

    // 页面数据
    menusMergeAfterBottom(contextMenuMap) {
      contextMenuMap['插入'] = () => this.handleInsertBottom()
    },
    async handleInsertBottom() {
      const options = await this.getMenuOptions()

      const tableData = this.tableData.bottom

      if (tableData.length) {
        const map = {}
        dfsFn(tableData, e => (map[e.menuName] = e))

        dfsFn(options, e => {
          if (map[e.menuName]) {
            e.writeFlag = map[e.menuName].writeFlag
            e.readFlag = map[e.menuName].readFlag
            e.approvalFlag = map[e.menuName].approvalFlag
          }
        })
      }

      this.$selectModal({
        title: '功能模块',
        key: 'menuName',
        width: '800px',
        allowMultiSelect: true,
        columns: [
          { field: 'name', title: '功能模块', tree: true },
          {
            field: 'writeFlag',
            title: '维护权限',
            cellType: 'checkbox',
            canEdit: true,
            canModify: true,
            multiple: true
          },
          {
            field: 'readFlag',
            title: '只读权限',
            cellType: 'checkbox',
            canEdit: true,
            canModify: true,
            multiple: true
          },
          {
            field: 'approvalFlag',
            title: '审核权限',
            cellType: 'checkbox',
            canEdit: true,
            canModify: true,
            multiple: true
          }
        ],
        options,
        confirm: (selectedCellInfos, tableData) => {
          // 删除原有的数据
          const bodyCells = this.$refs.bottomTable.vtable.getAllBodyCells()
          if (bodyCells.length) {
            this.$refs.bottomTable.handleDelete(bodyCells)
          }
          // 添加新的数据
          this.menuOptions = tableData
          this.$refs.bottomTable.handleInsert(tableData)
        }
      })
    },

    async getLockOptions() {
      const res = await this.$service.get(
        '/project-authorize/other-unit/lock/' + this.curentSelect.top.toUnitId
      )
      return sortRecords(
        res?.data?.map(e => ({ name: e.lockNumber, id: e.id })) || []
      )
    },
    async getUnitOptions() {
      const res = await this.$service.get('/unit/queryList')
      return sortRecords(res?.data || [])
    },
    // 获取功能模块选项
    async getMenuOptions() {
      const res = await this.$service.get('/sysMenu/queryList', {})
      dfsFn(res?.data, e => {
        e.menuParentId = e.parentId
        e.menuName = e.name
        e.menuId = e.id
        e.id = null
        e.writeFlag = false
        e.readFlag = false
        e.approvalFlag = false
      })
      const arr = sortRecords(res?.data || []).filter(e =>
        ['investment-estimate-software', 'bill-pricing-software'].includes(
          e.code
        )
      )
      return arr
    },

    onRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.curentSelect.left = obj
      this.getTableTop(obj)
    },
    onRowSelectTop(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.curentSelect.top = obj
      this.getTableTopRight(obj)
      this.getTableBottom(obj)
    },
    onRowSelectTopRight(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.curentSelect.topRight = obj
    },

    onModifyDataChangeLeft(getModifyData, cleanModifyData) {
      addCbFn(this.$service, '/project/batch', getModifyData, cleanModifyData)
    },
    onModifyDataChangeTop(getModifyData, cleanModifyData) {
      addCbFn(
        this.$service,
        '/project-authorize/unit/batch',
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            projectId: this.curentSelect.left.id
          })),
        () => this.getTableTop()
      )
    },
    onModifyDataChangeTopRight(getModifyData, cleanModifyData) {
      addCbFn(
        this.$service,
        'project-authorize/unit-lock/batch',
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            projectId: this.curentSelect.left.id,
            projectAuthorizeUnitId: this.curentSelect.top.id
          }))
      )
    },
    async onModifyDataChangeBottom(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/project-authorize/unit-menu/batch',
        getModifyData,
        cleanModifyData,
        arr => {
          const deletes = arr.filter(e => e.deleteFlag)
          const adds = []

          for (const val of this.menuOptions || []) {
            val.projectId = this.curentSelect.left.id
            val.projectAuthorizeUnitId = this.curentSelect.top.id
            val.menuParentId = -1

            adds.push(val)
            for (const child of val.children || []) {
              child.projectId = this.curentSelect.left.id
              child.projectAuthorizeUnitId = this.curentSelect.top.id
              child.menuParentId = val.menuId

              adds.push(child)
            }
          }

          return [...deletes, ...adds]
        }
      )
      this.menuOptions = null
    }
  }
}
</script>

<style scoped lang="less">
.project-management-permissions {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
  ::v-deep .left-right-box {
    .right {
      display: flex;
      height: 100%;
      gap: 10px;
      > div {
        flex: 1;
      }
    }
  }
}
.top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  .topLeft {
    flex: 1;
  }
  .topRight {
    flex: 1;
  }
}
</style>
